<template>
    <v-dialog v-model="show" max-width="700px" persistent>
        <v-card class="border-0">
            <v-card-title class="headline primary white--text">
                <v-icon dark left>mdi-party-popper</v-icon>
                Novidades da Versão {{ currentVersion }}
            </v-card-title>

            <v-card-text class="pt-4">
                <div v-for="(item, index) in newsItems" :key="index" class="mb-4">
                    <h3 v-if="item.title" class="title mb-2">{{ item.title }}</h3>
                    <div v-if="item.html" class="body-1" v-html="item.description"></div>
                    <p v-else class="body-1">{{ item.description }}</p>
                    
                    <div v-if="item.hasTour && !isStarter" class="mt-4 text-center">
                        <v-btn color="primary" outlined @click="startFeatureTour(item.routeName, item.tourId)">
                            <v-icon left>mdi-compass</v-icon>
                            Acesse o tour clicando aqui e confira essa nova funcionalidade
                        </v-btn>
                    </div>

                    <v-divider v-if="index < newsItems.length - 1" class="my-5"></v-divider>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="markAsRead">
                    Massa, entendi!
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import packageInfo from '../../package.json';
import TourService from '../services/TourService';

export default {
    name: 'TheNewsModal',
    data() {
        return {
            show: false,
            currentVersion: packageInfo.version,
            // In a real app, this could come from a JSON file or API
            newsItems: [
                {
                    html: true,
                    hasTour: true,
                    routeName: 'sessions',
                    tourId: 'medical_records_feature',
                    description: `
                        <p class="text-h6 font-weight-bold mb-4">📝 Novo Prontuário Digital: Mais completo e seguro!</p>
                        
                        <p>Temos o prazer de anunciar que o módulo de Prontuários e Registros de Atendimento foi totalmente reformulado para oferecer uma experiência mais rica, profissional e, acima de tudo, extremamente segura.</p>
                        
                        <p class="font-weight-bold mt-4 mb-2">O que há de novo?</p>
                        <ul class="mb-4 pl-4">
                            <li class="mb-2"><b>Editor de Texto Avançado (HTML):</b> Formate suas evoluções, crie listas e organize seus registros com total liberdade visual diretamente no sistema.</li>
                            <li class="mb-2"><b>Central Multimídia de Anexos:</b> Agora, além de PDFs, você pode anexar imagens, vídeos e áudios a cada sessão, mantendo todo o histórico organizado em um só lugar.</li>
                            <li class="mb-2"><b>Exportação Unificada:</b> Gere um arquivo PDF consolidado com os registros de todas as sessões realizadas com apenas um clique.</li>
                        </ul>
                        
                        <p class="font-weight-bold mt-4 mb-2">Segurança e Privacidade Inegociáveis</p>
                        <p class="mb-2">Sua confiança e a privacidade dos seus pacientes são nossa prioridade. Por isso, implementamos camadas extras de proteção:</p>
                        <ul class="mb-2 pl-4">
                            <li class="mb-2"><b>Criptografia de Ponta a Ponta:</b> Os dados e registros são criptografados de forma que apenas quem os criou tem permissão para lê-los.</li>
                            <li class="mb-2"><b>Proteção de Anexos e Banco de Dados:</b> Todos os arquivos anexados e informações no banco de dados passam por um processo de criptografia que impede qualquer tipo de leitura externa ou acesso não autorizado.</li>
                            <li class="mb-2"><b>Sigilo Total:</b> Garantimos que o conteúdo técnico das suas sessões permaneça inacessível para terceiros, reforçando o compromisso com o sigilo profissional.</li>
                        </ul>
                    `
                }
            ]
        };
    },
    computed: {
        isStarter() {
            return this.$store.state.auth.user?.access_profile_slug === 'starter';
        }
    },
    mounted() {
        this.checkNews();
    },
    methods: {
        checkNews() {
            const lastSeenVersion = localStorage.getItem('app_news_version');
            
            // If verify if version is newer or if never seen
            // Simple comparison: if strings are different. 
            // Better: semantic version comparison if needed, but strict equality is usually enough for "new version"
            if (lastSeenVersion !== this.currentVersion) {
                this.show = true;
            }
        },
        markAsRead() {
            localStorage.setItem('app_news_version', this.currentVersion);
            this.show = false;
        },
        startFeatureTour(routeName, tourId) {
            this.markAsRead();
            
            const initTour = () => {
                setTimeout(() => {
                    TourService.startTour(tourId || routeName, this.$router);
                }, 800); // Await modal close transition and page rendering
            };
            
            if (this.$route.name !== routeName) {
                this.$router.push({ name: routeName })
                    .then(() => initTour())
                    .catch((err) => {
                        if(err.name === 'NavigationDuplicated' || (err.message && err.message.includes('Avoided redundant navigation'))) {
                            initTour();
                        } else {
                            console.error(err);
                        }
                    });
            } else {
                initTour();
            }
        }
    }
}
</script>
